export default __webpack_public_path__ + "static/media/view-grid-active.2186acd9.svg";